import React from 'react';
import { Input } from 'antd';
import { LoadingOutlined, SearchOutlined } from '@ant-design/icons';

const inputFeedback = (state = {}) => ({
  suffix: state.status === 'pending' ? <LoadingOutlined spin aria-label="正在搜索" /> : null,
  status: state.error ? 'error' : undefined,
  value: state.query ?? '',
});

/** Controlled presentation; timing, cancellation and results belong to search. */
export default function ProjectSearchInput({ search, label, autoFocus = false, mode, projectId = '' }) {
  const composing = React.useRef(false);
  const activateSearch = search?.activate;
  React.useEffect(() => activateSearch?.(mode, projectId), [activateSearch, mode, projectId]);
  return (
    <Input
      allowClear
      aria-label={label}
      autoFocus={autoFocus}
      disabled={!search}
      onChange={event => search?.input(event.target.value, { composing: composing.current })}
      onClear={() => search?.clear()}
      onCompositionStart={() => {
        composing.current = true;
        search?.input(search.state.query, { composing: true });
      }}
      onCompositionEnd={event => {
        composing.current = false;
        search?.input(event.target.value);
      }}
      onPressEnter={event => {
        if (composing.current || event.isComposing || event.nativeEvent?.isComposing) return;
        void search?.submit();
      }}
      placeholder={label}
      prefix={<SearchOutlined aria-hidden="true" />}
      {...inputFeedback(search?.state)}
      size="large"
    />
  );
}
